export default __webpack_public_path__ + "static/media/percy.c1688d05.svg";